import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M10.194 2.133a1.59 1.59 0 0 0-2.366.131L4.64 6.25H2A1.75 1.75 0 0 0 .25 8v5c0 .966.784 1.75 1.75 1.75h3.75v-.018c.082.012.165.018.25.018h5.434a1.75 1.75 0 0 0 1.5-.85l2.567-4.277a1.75 1.75 0 0 0 .249-.9V8A1.75 1.75 0 0 0 14 6.25h-3.72a.25.25 0 0 1-.242-.31l.574-2.297a1.59 1.59 0 0 0-.418-1.51ZM5.75 13c0 .138.112.25.25.25h5.434a.25.25 0 0 0 .214-.121l2.566-4.277a.25.25 0 0 0 .036-.129V8a.25.25 0 0 0-.25-.25h-3.72a1.75 1.75 0 0 1-1.697-2.174l.574-2.296a.09.09 0 0 0-.158-.079L5.805 7.195a.25.25 0 0 0-.055.156V13Zm-1.5-5.25H2a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h2.25v-5.5Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  l
];
function n(r, d) {
  return e(), t("svg", a, [...c]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
